import { callAPI } from "../services/api";

export const getNBAbyLicenseAndState = async (licensePlate, licenseState, storeId) => {
  let route = `historical/multiple/by-license-plate/${licensePlate}/${licenseState}`

  try {  
    const data = await callAPI(route);
    return data;
  } catch (error) {
    throw (error)
  }
}